<p-dialog [(visible)]="visible" [style]="{'max-width': '450px', width: '100%'}"
          header="New Form Request" [modal]="true" [closable]="true" [responsive]="true" (onHide)="cancelRequest()">
    <div class="inputs-group" rte="fj">
        <div class="inputs-group-row" rte="fk">
            <label
                for="organizations"
                class="inputs-group-row-name"
                >User Type:</label
            >
            <div class="inputs-group-row-value" rte="fm">
                <p-multiSelect #organization="ngModel"
                            [appendTo]="'body'"
                            [(ngModel)]="selectedTargetGroups"
                            optionLabel="label"
                            dataKey="value"
                            [options]="targetGroups"
                            id="targetGroups"
                            name="targetGroups"
                            defaultLabel="Select User Type"
                            (onChange)="onRoleChange($event.value)">
                </p-multiSelect>
            </div>
        </div>
        <div class="inputs-group-row" rte="fk">
            <label
                for="organizations"
                class="inputs-group-row-name"
                >Users:</label
            >
            <div class="inputs-group-row-value" rte="fm">
                <p-multiSelect #organization="ngModel"
                            [appendTo]="'body'"
                            [(ngModel)]="selectedTargetUsers"
                            optionLabel="label"
                            dataKey="value"
                            [options]="targetUsers"
                            id="targetUsers"
                            name="targetUsers"
                            defaultLabel="Select users">
                </p-multiSelect>
            </div>
        </div>

        <div
            class="buttons-panel buttons-panel-top-margin"
        >
            <button
                pButton
                type="button"
                label="Cancel"
                class="p-button-secondary"
                (click)="cancelRequest()"
            ></button>
            <button
                pButton
                type="button"
                (click)="Request()"
                class="m-button-primary ml-2"
                label="Create request"
            ></button>
        </div>
    </div> 
</p-dialog> 


<warning-dialog 
    *ngIf="showWarning"   
    [text]="'You must complete this form before continuing. Please fill in the form.'"
    (closed)="showWarning=false">
</warning-dialog>

